<template>
  <div class="multicheck-dropdown" ref="dropdown">
    <div class="custom-selector">
      <button class="selector-toggle bg-filter-div text-theme" @click="toggleSelector">
        {{ selectedButtonText }}
      </button>
      <div v-if="showSelector" class="selector-menu bg-filter" ref="selectorMenu">
        <div v-show="searchable">
          <i class="bi bi-search"
            style="position: absolute; padding: 6px 10px; color: #9DA3A8 !important; z-index: 10;" />
          <input type="text" class="form-control input-search mb-3" v-model="searchText" placeholder="Search...">
        </div>
        <label class="selector-item" v-for="(value, index) in filteredOptions.slice(1)" :key="value + '-' + index">
          <input type="checkbox" :checked="isSelected(value)" @change="updateValue(value)" />
          {{ value }}
        </label>
        <div v-if="filteredOptions.length === 0" class="no-results">No results found</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckSelector",
  props: {
    value: {
      type: String,
      default: null,
    },
    searchable: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: 'Pilih Data'
    }
  },
  data() {
    return {
      showSelector: false,
      selectedValue: this.value,  // Initialize with the provided value
      searchText: ""
    }
  },
  computed: {
    filteredOptions() {
      return this.options.filter(option =>
        option.toLowerCase().includes(this.searchText.toLowerCase())
      );
    },
    selectedButtonText() {
      if (this.filteredOptions.length > 0) {
        if (this.isSelected(this.filteredOptions[0])) {
          return this.filteredOptions[0] ?? this.placeholder;
        }
      }
      return this.selectedValue;
    }
  },
  methods: {
    handleClickOutside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.showSelector = false;
      }
    },
    toggleSelector() {
      this.showSelector = !this.showSelector;
    },
    updateValue(value) {
      if (this.selectedValue === value) {
        this.selectedValue = "Semua Data";
        this.$emit('input', null);
      } else {
        this.selectedValue = value;
        this.$emit('input', value);
      }
      this.showSelector = false;
    },
    isSelected(value) {
      return this.selectedValue === value;
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
}
</script>

<style scoped>
.multicheck-dropdown {
  position: relative;
  display: inline-block;
}

.custom-selector {
  position: relative;
}

.selector-toggle {
  /* color: white; */
  /* background-color: #2d3135; */
  border: none;
  border-radius: .30rem;
  padding: 10px;
  cursor: pointer;
}

.selector-menu {
  display: block;
  position: absolute;
  /* background-color: #2d3135; */
  border: none;
  width: 300px;
  border-radius: .30rem;
  padding: 10px;
  z-index: 1000;
  margin-top: 7px;
}

.selector-item {
  display: flex;
  align-items: center;
}

.dark-mode .bg-filter-div {
  background: #2d3135 !important;
  border-color: #2d3135 !important;
}

.bg-filter-div {
  background-color: transparent !important;
  border: 1px solid #e8e8e8;
  color: #3f3f3f;
}


.selector-item input {
  margin-right: 10px;
}

.no-results {
  padding: 5px;
  color: white;
}
</style>
